import type { Bundle } from 'types';
import type {
  ProductAssociation,
  ProductAssociationWithImage,
} from 'components/Collection/pages/product/AssociatedProducts/types';
import Line from 'components/Line';
import Card from 'components/Card';
import Picture from 'components/Picture';

export const formatProductAssociations = (
  bundles: Bundle[],
  productAssociations: ProductAssociation[]
): ProductAssociationWithImage[] | null => {
  const IMAGE_LABEL = 'PDP_Hero';
  const output = [] as ProductAssociationWithImage[];

  for (const p of productAssociations) {
    const matchedBundle = bundles.find((b) => b.id === p.bundleId);
    const image = matchedBundle?.media?.find((m) => m.label === IMAGE_LABEL)?.url;

    if (image) {
      output.push({ imageUrl: encodeURI(image), ...p });
    }
  }

  return output.length ? output : null;
};

type Props = {
  products: ProductAssociationWithImage[];
};

const AssociatedProducts = ({ products }: Props) => (
  <div className="container">
    <div className="row">
      <div className="text-h1-display col-span-12 md:col-start-1 md:col-end-5 lg:col-start-2 ">
        <h2>
          You might <br /> also like
        </h2>
        <Line />
      </div>

      {products &&
        products.slice(0, 2).map((p, i) => (
          <Card
            className={`
              col-span-12 
              xs:col-span-6 
              sm:col-span-5 ${i === 0 ? 'sm:col-start-3' : ''}
              md:col-span-4
              ${i === 0 ? 'mb-16 xs:mb-0' : ''}
            `}
            key={p.name}
            trackerClass="tracker-cta-product-product_associations-211014-121913"
            href={p.ctaTarget}
            title={p.name}
            image={
              <div className="p-4 pb-0">
                <Picture url={p.imageUrl} alt={p.name} className="xs:aspect-ratio-1by1" />
              </div>
            }
            ctaTitle="View Product"
            children={<p className="text-sm mt-4 lg:my-8">{p.content}</p>}
          />
        ))}
    </div>
  </div>
);

export default AssociatedProducts;
